export default __webpack_public_path__ + "2a6e976c6e78425be9ab363abdec1132.svg";